import React from 'react'
import { Navigate, useParams, useSearchParams } from 'react-router-dom'
import { isTrafficConversionEnabled } from '../../services/V3PortalNavigation'

const sectionLabels: Record<string, string> = {
  'indie-dashboard': 'My Insights',
  'retail-performance': 'Performance',
  'retail-reports': 'Reports',
  'retail-data': 'Data',
  content: 'Content & Discussions',
  benchmarking: 'Benchmarking',
  trending: "What's Trending",
  'traffic-conversion': 'Traffic & Conversion',
  directory: 'Member Directory',
  connections: 'My Connections',
  messages: 'Messages',
  search: 'Search',
  billing: 'Account & Billing',
  help: 'Help',
  profile: 'Profile',
  'coaches-corner': "Coaches' Corner",
}

export default function PortalSectionPage() {
  const { section = 'search', client_code } = useParams()
  const [searchParams] = useSearchParams()
  const title = sectionLabels[section] || 'Portal'

  if (section === 'traffic-conversion' && !isTrafficConversionEnabled()) {
    return <Navigate to={client_code ? `/v3/client/${encodeURIComponent(client_code)}/simple-dashboard` : '/v3/home'} replace />
  }

  return (
    <section aria-labelledby="portal-section-title" className="min-h-[calc(100vh-102px)] bg-[#F9FAFB] px-6 py-10 sm:px-10">
      <div className="mx-auto max-w-5xl">
        <h1 id="portal-section-title" className="text-2xl font-semibold text-[#101828]">{title}</h1>
        {section === 'search' && searchParams.get('q') ? (
          <p className="mt-3 text-sm text-[#475467]">Search results for: "{searchParams.get('q')}" are not available yet.</p>
        ) : (
          <p className="mt-3 text-sm text-[#475467]">This area is not available yet.</p>
        )}
      </div>
    </section>
  )
}
